import { Error } from '@mui/icons-material'
import { Container, Stack, Typography } from '@mui/material'
import React from 'react'

type Props = {
  message?: string
  code?: string
}

const CanteenError: React.FC<Props> = ({ message }) => {
  const errorMessage = message ?? "We haven't been able to identify the cause of this issue"
  return (
    <Container sx={{ height: '100%' }}>
      <Stack
        spacing={2}
        justifyContent="center"
        alignItems="center"
        width="100%"
        direction="column"
        height="100%"
      >
        <Error color="error" sx={{ height: 100, width: 100 }} />
        <Typography textAlign="center" variant="h4">
          Oops, we aren&apos;t able to show you your menu at this time
        </Typography>
        <Typography textAlign="center" variant="body1">
          {errorMessage}
        </Typography>
        <Typography textAlign="center" variant="body1">
          Please contact support
        </Typography>
      </Stack>
    </Container>
  )
}

export default CanteenError
